import { LogsButton } from "@/components/Button";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Image,
  Input,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import SettingIcon from "./assets/set.png";
import { CloseIcon } from "@/components/icons";
import { CURRENCY_LIST } from "@/constants/currencys";
import { useUserInfo } from "@/context/UserInfo";
import { useState } from "react";

const LocalCurrency = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { currencyUnit } = useCurrencyExchange();
  const { handleSetCurrency, handleShowBalance, currencyInfo } = useUserInfo();
  const [searchValue, setSearchValue] = useState("");

  const filteredCurrency = CURRENCY_LIST.filter((item) => {
    const searchTerms = searchValue.toLowerCase().split(" ");
    const countryName = item.name.toLowerCase();

    return searchTerms.every((term) => {
      let lastIndex = -1;
      return term.split("").every((char) => {
        lastIndex = countryName.indexOf(char, lastIndex + 1);
        return lastIndex !== -1;
      });
    });
  });

  const handleDrawerOpen = () => {
    onOpen();
  };

  const handleDrawerClose = () => {
    onClose();
  };

  return (
    <Box>
      <LogsButton
        sx={{
          width: "90px",
          height: "35px",
          background: "#fff",
          color: "#D8762B",
          justifyContent: "space-between",
          padding: "0 10px 0 15px",
          position: "relative",
        }}
        onClick={handleDrawerOpen}
      >
        <Text
          sx={{
            color: "#FFD096",
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 500,
            position: "absolute",
            top: "-15px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "110px",
          }}
        >
          Local currency
        </Text>
        <Text
          sx={{
            fontWeight: 700,
            fontSize: "16px",
          }}
        >
          {currencyInfo?.localCurrency}
        </Text>
        <Image
          src={SettingIcon}
          sx={{
            width: "16px",
            height: "16px",
          }}
        ></Image>
      </LogsButton>
      <Drawer
        isOpen={isOpen}
        placement="bottom"
        onClose={handleDrawerClose}
        autoFocus={false}
      >
        <DrawerOverlay />
        <DrawerContent
          sx={{
            padding: "20px 0px 20px 0px",
            background: "#fff",
            width: "100%",
          }}
        >
          <DrawerBody
            sx={{
              padding: "0",
              position: "relative",
            }}
          >
            <CloseIcon
              onClick={onClose}
              style={{
                position: "absolute",
                top: "4px",
                right: "20px",
                width: "16px",
                height: "16px",
                cursor: "pointer",
                color: "#000",
              }}
            ></CloseIcon>
            <Text
              sx={{
                color: "#D8762B",
                textAlign: "center",
                fontFamily: "DIN",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 700,
              }}
            >
              Currency
            </Text>
            <Box sx={{ padding: "0 30px", marginTop: "20px" }}>
              <Text sx={{ color: "#333", fontSize: "16px" }}>
                Search country
              </Text>
              <Input
                variant="unstyled"
                placeholder="input to search"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                sx={{
                  margin: "6px 0",
                  fontSize: "14px",
                  height: "20px",
                  color: "#333",
                  "&::placeholder": {
                    color: "#999",
                  },
                }}
              />
            </Box>
            <Box
              sx={{
                height: "50vh",
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
                position: "relative",
                "-webkit-overflow-scrolling": "touch",
                overscrollBehavior: "contain",
              }}
              onTouchMove={(e) => {
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {filteredCurrency.map((item) => (
                <Flex
                  key={item.currency}
                  sx={{
                    height: "45px",
                    background:
                      currencyUnit === item.currency ? "#FFD7AC" : "#fff",
                    padding: "0 30px",
                  }}
                  align={"center"}
                  onClick={async () => {
                    await handleSetCurrency(item.currency, true);
                    handleShowBalance(true);
                    onClose();
                  }}
                >
                  <Image
                    src={`https://images-country.meld.io/${item.countryCode}/flag.svg`}
                    sx={{
                      width: "30px",
                      height: "30px",
                      marginRight: "12px",
                      borderRadius: "50%",
                    }}
                    fallback={
                      <Box
                        width="30px"
                        height="30px"
                        bg="gray.200"
                        borderRadius="50%"
                      />
                    }
                  ></Image>
                  <Text
                    sx={{
                      marginRight: "15px",
                      color: "#333",
                    }}
                  >
                    {item.currency}
                  </Text>
                  <Text
                    sx={{
                      color: "#848484",
                      fontSize: "16px",
                      fontWeight: 500,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.name}
                  </Text>
                </Flex>
              ))}
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default LocalCurrency;
